import React from "react";
import styled from "styled-components";

import { Image } from "@chakra-ui/core";

import warningIcon from '../../../assets/icons/warning.svg';

const NotFound = () => {
  return (
    <Wrapper>
      <div style={{ padding: '0 24px' }}>
        <Image src={warningIcon} alt="Warning Icon" mb="32px" />
        <Title>Desculpe,</Title>
        <Subtitle>Desculpe, mas a página que você procura não está disponível.</Subtitle>
      </div>

      <Faq>
        <Intro>O que aconteceu?</Intro>
        <Message><Strong>Erro: </Strong>O endereço pode ter sido digitado incorretamente.</Message>
        <Message><Strong>Link desatualizado: </Strong>Se este link foi encontrado por meio de busca ou o acesso foi feito por outro site, ele pode estar desatualizado.</Message>
        <Message><Strong>Página removida: </Strong>A página pode ter sido removida do site.</Message>
      </Faq>
    </Wrapper>
  );
};

export default NotFound;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  text-align: center;
  gap: 96px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 142px 0 135px;

  @media (max-width: 1400px) {
    padding-left: 2em;
    padding-right: 2em;
  }

  @media (max-width: 1200px) {
    padding-left: 1em;
    padding-right: 1em;
  }

  @media (max-width: 768px) {
    gap: 72px;
    padding: 112px 24px 80px;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  font-weight: 500;
  line-height: 120%;
  color: #DD1D21;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  color: #3B3B3B;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 140%;
  }
`;

const Message = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  color: #3B3B3B;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Faq = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  background: #F5F5F5;
  border: solid 1.5px #E2E2E2;
  border-radius: 24px;
  padding: 56px;
  text-align: left;

  @media (max-width: 1400px) {
    padding: 48px;
  }

  @media (max-width: 1200px) {
    padding: 40px;
  }

  @media (max-width: 768px) {
    padding: 40px 32px;
    border-radius: 16px;
  }
`;

const Intro = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 130%;
  color: #3B3B3B;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Strong = styled.strong`
  color: #DD1D21;
  font-weight: 600;
`;